module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Left-2-08f7bdab1c42d5097a3795da72c3eda1.svg";